import { Component } from '@angular/core';
import { KENDO_GRIDLAYOUT } from '@progress/kendo-angular-layout';

@Component({
  selector: 'unity-page-actions-layout',
  imports: [KENDO_GRIDLAYOUT],
  templateUrl: './page-actions-layout.component.html',
  styleUrl: './page-actions-layout.component.scss',
})
export class PageActionsLayoutComponent {}
